import moment from "moment";

export const useGetLastFiveSchoolYears = () => {
    const currentDate = moment();
    const startingYear = moment().year() - 2;
    const stoppingYear = startingYear + 5;

    const lastFiveYears = Array.from(
        { length: Math.ceil((stoppingYear - startingYear) / 1) },
        (_, i) => startingYear + i * 1
    );

    return lastFiveYears.map((year, index) => {
        const startOfYear = moment(`${year}-08-01`, "YYYY-MM-DD");
        const endOfYear = moment(`${year + 1}-07-31`, "YYYY-MM-DD");

        return {
            id: index + 1,
            label: `${year}-${year + 1}`,
            value: `${year}-${year + 1}`,
            isCurrent: currentDate.isBetween(startOfYear, endOfYear, "day", "[]"),
        };
    });
}
